import { retornoHashValor } from '../cripotografia/hash';

import axios from 'axios';

const url = retornoHashValor(process.env.REACT_APP_2);

let retorno;

export const BuscarCep = async cep => {
    await axios.get(`${url + cep  }/json/`, {
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then(response => response.data)
        .then(responseJson => {
            if (responseJson) {
                retorno = responseJson;
            } else {
                retorno = { erro: 'parametros errados' };
            }
        })
        .catch(err => { retorno = err.message; });

    return retorno;
};
